import React, { useEffect } from "react";
import { URInput } from "../input";
import styles from "./chatSticker.module.scss";
import { chats, initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import { ChatService } from "../../../base/chatService";
import { fileUploadStricker } from "../../../base/socketChatService/utils";
import { Tooltip } from "antd";
function URChatSticker() {

  //*const [showSticker, setSticker] = useState([]);
  const stickersList: chats = useSelector((state: initialStateModel) => state.chatReducer);

  useEffect(() => {
    if (!stickersList.isStickers) {
      ChatService.getStcikers();
    }
  }, [stickersList.stickers]);

  /** 
   * @description SendStickers
   * @param url 
   * @param fileName 
   * @param mimeType 
   */
  const sendStickers = (url: any, fileName: any, mimeType: any) => {
    let filesinfo:any = {};
    let fileType:any = "image/webp";
    fileName = fileName.replace(/"/g, "");
    fileName = fileName.trim();
    let file: any = "";
    var blob = "";
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.onload = async function() {
      blob = xhr.response;
      file = await new File([blob], fileName, { type: fileType });
      filesinfo.fileName = file.name;
      filesinfo.fileType = file.type;
      filesinfo.filePath =  window.URL.createObjectURL(file);
      filesinfo.filesize =file.size;
      filesinfo.targetFile = file;
      filesinfo.messageType = "IMAGE";
      filesinfo.isCloudfiles = false;
      fileUploadStricker(filesinfo);
    };
    xhr.send();
  };

  return (
    <>
      <div className={styles.popOverContainer}>
        <div className={styles.topHeadersec}>
          <div className={styles.listdrapdrop}>
            <ul className={styles.toplistIcon}>      
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Frequently Used"><li className={styles.active}>
                    <span className="icon_clock"></span> 
                </li></Tooltip>       
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Productivity"><li className={styles.active}>
                    <span className="icon_setting"></span> 
                </li></Tooltip>
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Greetings"><li>
                    <span className="icon_gift"></span> 
                </li></Tooltip>
                <Tooltip  mouseEnterDelay={0.5} placement="top" title="Emotions"><li>
                    <span className="icon_smile"></span> 
                </li></Tooltip>
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Feelings"><li>
                    <span className="icon_handtwo"></span> 
                </li></Tooltip>
              </ul>     
            </div>
          </div>
          <div className={styles.middleHeadersec}>
            <URInput placeHolder='Search' className='searchBox gifSearch'/>
            {/* <span className="icon_close"></span> */}
          </div>
        <div className={styles.topInnerBodySec}>
        <h3>Frequently Used</h3>
          <div className={`${styles.listdrapdrop} scroller`}>
            <ul className={styles.orderItem}>
              {stickersList.stickers && stickersList.stickers.map((data: any, i: any) => {
                let fileName = data.substring(data.lastIndexOf("/") + 1);
                let extension = "image/webp";
                return (
                  <li key={i}>
                    <img alt=""
                      src={data}
                      onClick={() =>
                        sendStickers(data, fileName, extension)
                      }
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export {
  URChatSticker
};


